module.exports = __webpack_public_path__ + "static/media/apple_pay.012fd0f2.svg";